import {useState} from "react";
import {Outlet, useLocation} from "react-router-dom";
import {Branding} from "@/components/Branding";
import {FloatingSheet} from "@/components/FloatingSheet";
import {useConfiguration} from "@/features/configuration";
import type {LatLng} from "@/features/map";
import {useElementOffset} from "@/hooks/useElementOffset";
import {OrderMap} from "./components/OrderMap";
import {OrderProvider} from "./context";
import styles from "./Order.module.css";
import {FALLBACK_MAP_CENTER} from "./utils/constants";

function OrderContent() {
    const {data: configuration, isLoading: isLoadingConfiguration} = useConfiguration();
    // Use state instead of ref to trigger re-render when element is available
    const [sheetElement, setSheetElement] = useState<HTMLDivElement | null>(null);
    const sheetRef = (node: HTMLDivElement | null) => {
        setSheetElement(node);
    };
    const sheetOffset = useElementOffset(sheetElement);
    const {pathname} = useLocation();
    const isConfirmation = pathname.includes("confirmation");

    const defaultMapCenter: LatLng = {
        lat: configuration?.callerIpLocation?.lat ?? FALLBACK_MAP_CENTER.lat,
        lng: configuration?.callerIpLocation?.lon ?? FALLBACK_MAP_CENTER.lng,
    };

    if (isLoadingConfiguration) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.floatingWrapper}>
                <FloatingSheet ref={sheetRef}>
                    <Branding />
                    <Outlet />
                </FloatingSheet>
            </div>

            <OrderMap
                isConfirmation={isConfirmation}
                defaultCenter={defaultMapCenter}
                sheetOffset={sheetOffset}
            />
        </div>
    );
}

export function Order() {
    return (
        <OrderProvider>
            <OrderContent />
        </OrderProvider>
    );
}
